import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { CATALOG_FILTER } from 'lib/core/resources/constants'
import { ReactComponent as Chevron } from 'lib/core/resources/svg/chevron-down.svg'
import { ChangeFilterHandler, FilterOptions, getPriceFilterRange, LayeredPriceFilter } from 'lib/modules/catalog'
import { Drops } from 'scenes/Product/components/DescriptionTabs/styled'
import { ReactComponent as DropSvg } from 'resources/svg/icons/drop.svg'

interface Props {
  isFetching: boolean
  filterOptions: FilterOptions
  visibleItems: number
  handleFilterChange: ChangeFilterHandler
  onApplyFilters?: () => void
  isDraft?: boolean
  isMulti?: boolean
}

export const Filter = ({
  filterOptions,
  handleFilterChange,
  onApplyFilters,
  visibleItems,
  isFetching,
  isDraft = true,
  isMulti = true
}: Props) => {
  const {
    code,
    items,
    name,
    selected,
    settings
  } = filterOptions

  const intl = useIntl()
  const [toggle, setToggle] = useState(Boolean(settings?.collapsed))
  const [seeMore, setSeeMore] = useState(false)
  const isPriceFilter = code === CATALOG_FILTER.PRICE
  const priceRange = isPriceFilter ? getPriceFilterRange(items) : undefined

  if (!items.length) {
    return null
  }

  if (isPriceFilter && !priceRange) {
    return null
  }

  const className = toggle ? 'isClosed' : undefined
  const isAbsorvencyLevel = code === 'padliner_absorbency' || code === 'underwear_absorbency'

  return (
    <li key={code}>
      <div
        onClick={() => setToggle(toggle => !toggle)}
      >
        <strong>
          <span>{name}</span>
          <Chevron className={className} />
        </strong>
      </div>
      <div className={className}>
        {priceRange ? (
          <LayeredPriceFilter
            autoSubmit
            minRange={priceRange[0]}
            maxRange={priceRange[1]}
            isFetching={isFetching}
            onChange={(e) => {
              handleFilterChange({
                requestVar: code,
                value: [e],
                conf: {
                  draft: isDraft
                }
              })
              if (!isDraft) {
                onApplyFilters?.()
              }
            }}
            value={selected?.[0].value}
          />
        ) : (
          <>
            {(seeMore ? items : items.slice(0, visibleItems)).map((item) => {
              const absorvencyLabel = isAbsorvencyLevel ? (item.label as string).split(' ') : undefined
              return (
                <div key={`f-${item.requestVar}-${item.value}`}>
                  <label>
                    <input
                      type='checkbox'
                      checked={Boolean(selected?.find(el => el.value === item.value))}
                      value={item.value}
                      onChange={(e) => {
                        handleFilterChange({
                          requestVar: item.requestVar,
                          value: [item.value],
                          conf: {
                            draft: isDraft,
                            multiple: isMulti
                          }
                        })
                        if (!isDraft) {
                          onApplyFilters?.()
                        }
                      }}
                    />
                    <span>
                      {isAbsorvencyLevel ? (
                        <Drops>
                          {Array.from(Array(parseInt(absorvencyLabel?.[0] as string)).keys()).map(drop => (
                            <DropSvg key={drop} />
                          ))}
                          <span> {absorvencyLabel?.[1]}</span>
                        </Drops>
                      ) : (
                        <>{item.label}</>
                      )}
                    </span>
                  </label>
                </div>
              )
            })}
            {items.length > visibleItems && (
              <div>
                <button
                  onClick={() => setSeeMore(val => !val)}
                >
                  {seeMore
                    ? intl.formatMessage({ id: 'action.seeLess' })
                    : intl.formatMessage(
                      { id: 'action.seeMoreWithCount' },
                      { count: items.length - visibleItems }
                    )}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </li>
  )
}
